import ClassicLayout from "./ClassicLayout.jsx";
import V2Layout from "../../v2/V2Layout.jsx";

/**
 * Layout registry: maps layout key to component.
 * A layout owns the persistent chrome (nav, footer) and renders routes as children.
 */
export const LAYOUTS = {
  classic: ClassicLayout,
  v2: V2Layout,
};

export const DEFAULT_LAYOUT = "v2";

/**
 * Resolves which layout to render.
 *
 * ?layout= is a dev escape hatch mirroring ?template= — it lets the v2 shell
 * be previewed without changing what any real visitor resolves to. The
 * default is the only thing production uses.
 */
export function resolveLayout(layoutKey) {
  if (typeof window !== "undefined") {
    const urlLayout = new URLSearchParams(window.location.search).get("layout");
    if (urlLayout && LAYOUTS[urlLayout]) return LAYOUTS[urlLayout];
  }
  return LAYOUTS[layoutKey] || LAYOUTS[DEFAULT_LAYOUT];
}
